import { FC } from "react";
import { useParams } from "react-router";

import { Campaign, CategoryTrees } from "@vviinn/user-managment-client-ts";

import { DetailedCard } from "../../../components/GeneralUI/DetailedCardComponents";

import { CampaignTileIcon } from "./CampaignTileIcon";
import { CampaignTileFooter } from "../../components/CampaignTileFooter";
import { campaignTypeTitles } from "../../constants";
import { CampaignKeynote } from "./CampaignKeynote";

export type CampaignTileProps = {
  campaign: Campaign;
  handleSwitchChange: (id: Campaign["id"]) => (value: boolean) => void;
  isExtended: boolean;
  categories?: CategoryTrees;
  classNames?: string;
};

export const CampaignTile: FC<CampaignTileProps> = ({
  campaign,
  handleSwitchChange,
  isExtended,
  categories,
}: CampaignTileProps) => {
  const { type, active, id, name } = campaign;
  const { companyId, siteId } = useParams();

  return (
    <DetailedCard
      link={`/company/${companyId}/site/${siteId}/campaigns/service/${id}`}
      icon={<CampaignTileIcon type={type} isActive={active} />}
      title={name}
      subtitles={[{ type: "text", text: campaignTypeTitles[campaign.type] }]}
      onChange={handleSwitchChange(id)}
      isActive={active}
      permissions="campaign:basic_config:update"
      isExtended={isExtended}
      specialStyle={`rounded-2xl bg-stone-50 dark:bg-stone-800 card-${type}-${active ? "active" : "inactive"}`}
      dataId={id}
    >
      <CampaignKeynote campaign={campaign} />
      <CampaignTileFooter campaign={campaign} categories={categories} />
    </DetailedCard>
  );
};
